import React, {Component} from 'react'
import { Card, Image, Header, Icon} from 'semantic-ui-react'

class InvoiceDetails extends Component {

    render() {
        let plan = this.props.plan
        let getPlan = () => {
            let image = <Image size='tiny' floated='right' src='./assets/images/i_promotion@3.png'/>
            if (plan.type === "gold")
                image = <Image size='tiny' floated='right' src='./assets/images/i_pro@3.png'/>
            else if (plan.type === "goldlite")
                image = <Image size='tiny' floated='right' src='./assets/images/i_pro@3.png'/>
            else if (plan.type === "silver")
                image = <Image size='tiny' floated='right' src='./assets/images/i_lite@3.png'/>
            else if (plan.type === "bronze")
                image = <Image size='tiny' floated='right' src='./assets/images/i_trial@3.png'/>

            return <Card key={plan.id}>
                <Card.Content>
                    {image}
                    <Card.Header>
                        {plan.title}
                    </Card.Header>
                    <Card.Meta>
                        {plan.description}
                    </Card.Meta>
                    <Card.Description floated='center'>
                        $<strong>{plan.price}</strong> a month
                    </Card.Description>
                </Card.Content>

            </Card>
        }
        return (
            <div>
                <Header as='h3' dividing>
                    <Icon name='file' />
                    <Header.Content>
                        Invoice Details
                        <Header.Subheader>
                            Programs Purchase
                        </Header.Subheader>
                    </Header.Content>
                </Header>
                <Card.Group centered>
                    {getPlan()}
                </Card.Group>
            </div>
        )
    }
}

export default InvoiceDetails


// WEBPACK FOOTER //
// ./src/containers/register/InvoiceDetails.js